import React, { useState, useEffect, useContext } from "react";

import useDocumentTitle from "../../utils/useDocumentTitle";
import AuthApi from "../../context/AuthApi";

import { LogsTable } from "./LogsTable";
import styles from "./Logs.module.scss";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { Tabs, Tab } from "../../components/Tabs";
import { Metric, MetricsWrapper } from "../../components/Metric";
import { getLocalValue } from "../../utils/auth";
import Search from "../../components/Search";
import { useTranslation } from "react-i18next";

export function LogsPersonal(props) {
  const { t } = useTranslation();
  useDocumentTitle(props.title);
  const Auth = useContext(AuthApi);
  const [searchKey, setSearchKey] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");

  useEffect(() => {
    //check for filterdata in storage
    const logsSearchKey = sessionStorage.getItem("logsSearchKey");
    if (logsSearchKey && logsSearchKey !== "") {
      setSearchInputValue(logsSearchKey);
      setSearchKey(logsSearchKey);
      sessionStorage.removeItem("logsSearchKey");
    }
  }, []);

  const logsTableHeader = [
    {
      name: "session_datetime",
      label: t("logs.sessionStartDate"),
      width: "12%",
    },
    { name: "session_id", label: "Session ID", width: "8%" },
    { name: "duration", label: t("logs.duration"), width: "8%" },
    { name: "type", label: t("logs.type"), width: "8%" },
    { name: "subject", label: t("logs.subjects"), width: "13%" },
    { name: "coachee_name", label: t("logs.name"), width: "11%" },
    { name: "coachee_employee_id", label: t("logs.employeeID"), width: "8%" },
    {
      name: "completion_datetime",
      label: t("logs.completionDate"),
      width: "12%",
    },
    { name: "status", label: t("logs.status"), width: "10%" },
  ];

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("leftNavigation.logs")}</SectionTitle>
            {Auth.isCoach && (
              <Tabs>
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  linkTo={"/logs/team"}
                />
                <Tab
                  label={"personal"}
                  tabName={t("tabs.personal")}
                  defaultTab={true}
                />
              </Tabs>
            )}
            <MetricsWrapper>
              <Metric
                label={t("logs.totalLogs")}
                api="getTotalPersonalSessionLogs"
                filterParams={`&search=${searchKey}`}
                responseKey="response.data.data"
              />
              <Metric
                label={t("logs.averageDuration")}
                api="getAveragePersonalSessionDuration"
                filterParams={`&search=${searchKey}`}
                responseKey="response.data.data"
              />
              <Metric
                label={t("logs.longestDuration")}
                api="getLongestPersonalSessionDuration"
                filterParams={`&search=${searchKey}`}
                responseKey="response.data.data"
              />
              <Metric
                label={t("logs.shortestDuration")}
                api="getShortestPersonalSessionDuration"
                filterParams={`&search=${searchKey}`}
                responseKey="response.data.data"
              />
            </MetricsWrapper>

            <Search
              searchInputValue={searchInputValue}
              handleSearch={val => {
                setSearchKey(val);
              }}
            />
            <LogsTable
              getDataFrom={"/api/getPersonalSessionLogs"}
              uid={getLocalValue("uid")}
              tableHeader={logsTableHeader}
              searchKey={searchKey}
            />
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
